import React from "react";

const dummyInsights = [
  {
    id: 1,
    agenda: "Vendor Meeting",
    score: 85,
    summary:
      "Discussed pricing and delivery timelines. Vendor agreed to trial order next week.",
    suggestedAction: "Follow-up on order confirmation via email.",
  },
  {
    id: 2,
    agenda: "Investor Meeting",
    score: 70,
    summary:
      "Investor interested in Q1 growth, requested additional metrics on revenue streams.",
    suggestedAction: "Prepare revenue sheet and share before next meeting.",
  },
  {
    id: 3,
    agenda: "Team Sync",
    score: 95,
    summary:
      "Team aligned on project milestones, tasks distributed effectively.",
    suggestedAction: "Monitor progress on Jira and weekly follow-up.",
  },
];

const GASAIInsights = () => {
  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-xl font-semibold mb-4">AI Insights</h2>

      {dummyInsights.map((insight) => (
        <div
          key={insight.id}
          className="border border-cyan-700 rounded-xl p-4 mb-4 bg-black/50"
        >
          <h3 className="font-semibold text-lg">{insight.agenda}</h3>
          <p className="text-xs text-gray-400 mb-2">
            Effectiveness Score:{" "}
            <span
              className={`font-semibold ${
                insight.score > 80
                  ? "text-green-400"
                  : insight.score > 60
                  ? "text-yellow-400"
                  : "text-red-500"
              }`}
            >
              {insight.score}%
            </span>
          </p>
          <p className="text-sm mb-2">
            <strong>Summary:</strong> {insight.summary}
          </p>
          <p className="text-sm text-cyan-200">
            <strong>Suggested Action:</strong> {insight.suggestedAction}
          </p>
        </div>
      ))}

      <div className="mt-6 text-xs text-gray-500">
        * Insights are generated using AI summarization (dummy data for now).
      </div>
    </div>
  );
};

export default GASAIInsights;

